import axios from 'axios';
import { metaValue } from 'helpers/dom-helper';
import * as qs from 'qs';

export default function setupAxios({ includeAuthToken = true, serializeParams = true } = {}): void {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

  axios.defaults.headers.common['X-CSRF-Token'] = csrfToken || '';
  axios.defaults.headers.common.Accept = 'application/json';
  // Action cable client id.
  axios.defaults.headers.common['X-CID'] = metaValue('client-id');

  const authToken = document.querySelector('meta[name="api-auth-token"]')?.getAttribute('content');
  if (includeAuthToken && authToken) {
    axios.defaults.headers.common['X-API-AUTH-TOKEN'] = `Token token=${authToken}`;
  }

  if (serializeParams) {
    axios.defaults.paramsSerializer = (params) => qs.stringify(params, { arrayFormat: 'brackets' });
  }
}

/**
 * @description Returns an axios error or a general JS error
 */
export function getError(error: unknown): string {
  if (axios.isAxiosError(error)) {
    return error.message;
  }

  return 'Something went wrong';
}
